<ng-content select="[header]" />
<lyceo-card class="card">
  <ng-content />
</lyceo-card>
<ng-content select="[footer]" />
